<template>
  <div>
    <div v-if="this.$store.state.customModule.product" class="subject">
      <img class="content" src="http://hpc.devotedigital.cn/resources/img/total.png">
      <img class="overview" src="http://hpc.devotedigital.cn/resources/img/Product1.png">
      <img class="close" src="http://hpc.devotedigital.cn/resources/img/close.png" @click="productShowClick">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    productShowClick() {
      this.$store.commit('customModule/setProduct', false)
      this.$emit('divClose')
    }
  }
}
</script>
<style lang='scss' scoped>
.subject {
  position: absolute;
  width:61vw;
  height: 32vw;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  // background-color: aqua;
}
.content {
  position: absolute;
  width: 61vw;
  height:32vw;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.overview {
  position: absolute;
 width: 1200px;
    height: 690px;
  left: 50%;
  top:49.5%;
  transform: translate(-50%, -50%);
}
.close {
  position: absolute;
  right: -50px;
  top: 10px;
  width: 60px;
  height: 60px;
  cursor: pointer;
}
</style>
